// tables/RevenueTable.jsx
import React from 'react';
import { TableContainer, Table, TableBody, TableRow, TableCell } from '@mui/material';

const RevenueTable = ({ data }) => {
  return (
    <TableContainer>
      <Table size="small">
        <TableBody>
          {data?.map((item) => (
            <TableRow key={item.service}>
              <TableCell>{item.service}</TableCell>
              <TableCell align="right">${item.amount.toLocaleString()}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RevenueTable;